import React from "react";
import styled from "styled-components";
import { ApiResult } from "../../../lib/CmsApi";
import TopBox from "../../common/TopBox";
import FullImageIntro from "../../common/FullImageIntro";
import { TopicItem } from "../../common/TopicGrid";
import Content from "../../common/Content";
import Label from "../../common/Label";
import Grid from "../../common/Grid";
import { colors, spacing } from "../../theme";
import CustomPageHead from "../../common/CustomPageHead";

export type Props = ApiResult<"loadAboutUs"> & {
  articles: ApiResult<"listAboutUsArticles">["items"];
};

const StyledLabel = styled(Label)`
  color: ${colors.blue};
  ${spacing("margin-bottom", 32)}
`;

export default function AboutUsPage(props: Props) {
  return (
    <>
      <CustomPageHead
        title={props.name}
        desc={props.header && props.header.intro}
        seo={props.seo}
      />
      <TopBox
        title={props.name}
        breadCrumpPath={[{ title: props.name, route: "aboutUs" }]}
        subLinks={props.articles.map(a => ({
          route: "aboutUsArticle",
          title: a.overline,
          params: { slug: a.slug }
        }))}
      />
      <main>
        {props.header && props.header.image && (
          <FullImageIntro
            image={props.header.image}
            headline={props.header.headline}
            fallBackAlt={props.header.headline}
            intro={props.header.intro}
          />
        )}
        <Content padded bottomMargin>
          <Grid columns={3} tabletColumns={3} mobileColumns={2} tinyColumns={1}>
            {props.articles.map(a => (
              <TopicItem
                key={a.slug}
                type={a.overline}
                headline={a.name}
                cta={"Mehr erfahren"}
                link={{ route: "aboutUsArticle", params: { slug: a.slug } }}
              >
                <StyledLabel small regular>
                  {a.description}
                </StyledLabel>
              </TopicItem>
            ))}
          </Grid>
        </Content>
      </main>
    </>
  );
}

AboutUsPage.getImages = (props: Props) => {
  if (props.header) return FullImageIntro.getImages(props.header);
  return [];
};
